// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffportal/v1/user_service.proto (package bffportal.v1, syntax proto3)
/* eslint-disable */

import { UserService } from "./user_service_pb";

/**
 * @generated from rpc bffportal.v1.UserService.GetMe
 */
export const getMe = UserService.method.getMe;

/**
 * @generated from rpc bffportal.v1.UserService.UpdateUserLanguage
 */
export const updateUserLanguage = UserService.method.updateUserLanguage;
